import React, { useRef, useState } from "react";
import { useRedirect } from "react-admin";
import loginAvatar from "./../static/login-avatar.png";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import NotificationMessage, {
  notificationType,
} from "../components/NotificationMessage/NotificationMessage";
import fdAuthProvider from "../authProvider/authProvider";
import { routePaths } from "./SidebarMenu";
// import FdTextField from "../components/UIComponents/TextField/FdTextfield";
import FdButton from "../components/UIComponents/Button/FdButton";
import FdTypography from "../components/UIComponents/Typography/FdTypography";
import FdAvatar from "../components/UIComponents/Avatar/FdAvatar";
import FdCard from "../components/UIComponents/Card/FdCard";
import {signIn as classes} from './styles';

import FdTextField from "../components/UIComponents/TextField/FdTextfield";
import { useForm } from "react-hook-form";
interface FormData {
  email: string;
}

interface FormProps {
  initialValues: FormData;
  onEmailSent: Function;
  onLoading: Function;
  onError: Function;
}

const PasswordForgotForm = (props: FormProps) => {
  const { initialValues, onEmailSent, onLoading, onError } = props;

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: initialValues,
  });

  async function onSubmit(values: FormData) {
    try {
      onLoading(true);
      await fdAuthProvider.resetPassword({
        email: values.email,
      });

      onEmailSent();
      onLoading(false);
    } catch (error: any) {
      onError("User doesn't exist");
      onLoading(false);
      console.log(error);
    }
  }

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <Box mt={2} mb={4}>
          {/* we are submitting the username for this field */}
          <FdTextField
            name="email"
            id="email"
            label="Username"
            type="email"
            register={register}
            required
            error={errors.email?.type === "required"}
            errorMsg={errors.email && "Username is required"}
            // InputProps={{ disableUnderline: true }}
          />
        </Box>
        <Box>
          <FdButton
            type="submit"
            size="medium"
            fullWidth
            ButtonName="Request"
          />
        </Box>
      </form>
    </>
  );
};

const PasswordForgot = () => {
  const [emailSent, setEmailSent] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const redirect = useRedirect();
  const notificationRef = useRef<any>();

  return (
    <>
      <Box sx={classes.wrapper}>
        <FdCard sx={classes.card}>
          <FdAvatar src={loginAvatar} sx={classes.avatar} />
          <FdTypography
            variant="h2"
            component="h2"
            label={
              emailSent ? "Your new pass is on its way!" : "Forgot password?"
            }
          />
          <Box mt={1} mb={2}>
            <FdTypography
              label={
                emailSent
                  ? "Check your email inbox!"
                  : "Please fill in your username"
              }
            />
          </Box>

          {loading && <CircularProgress />}

          {emailSent && (
            <Box>
              <FdButton
                variant="contained"
                color="primary"
                size="medium"
                fullWidth
                onClick={() => {
                  redirect(`/${routePaths.LOGIN}`);
                }}
                ButtonName="Login"
              ></FdButton>
            </Box>
          )}
          {!emailSent && !loading && (
            <PasswordForgotForm
              initialValues={{ email: "" }}
              onEmailSent={() => {
                setEmailSent(true);
              }}
              onLoading={(isLoading: boolean) => {
                setLoading(isLoading);
              }}
              onError={(error: string) =>
                notificationRef.current?.show(error, notificationType.Error)
              }
            />
          )}
        </FdCard>
      </Box>
      <NotificationMessage ref={notificationRef} />
    </>
  );
};

export default PasswordForgot;
